import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import type { LoanRequest_LiabilityHideStateChanged } from 'cpool-events';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { APICommunicator } from '~/api/APICommunicator';
import { setQueryPosition } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

export const useChangeLiabilityHideState = ({ loanRequestId }: { loanRequestId: string }) => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation({
        mutationFn: (payload: LoanRequest_LiabilityHideStateChanged['payload']) => {
            return APICommunicator.sendCommand({
                aggregateId: loanRequestId,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: LOAN_REQUEST_COMMANDS.changeLiabilityHideState,
                payload,
            });
        },
        onError: () => {
            toast.error(t('EXISTING_LOANS.TOASTS.ERROR.CHANGE_LIABILITY_HIDE_STATE'));
        },
        onSuccess: ({ position }) => {
            setQueryPosition(JSON.stringify(queryKeys.getOfferRequestConditionsLatest(loanRequestId)), position);
            queryClient.invalidateQueries({ queryKey: queryKeys.getOfferRequestConditionsLatest(loanRequestId) });
            toast.success(t('EXISTING_LOANS.TOASTS.SUCCESS.CHANGE_LIABILITY_HIDE_STATE'));
        },
    });
};
